
import { defineComponent,ref,Ref,provide,watchEffect,onMounted } from 'vue';
import gAuth from 'vue3-google-auth';
import {Usuario} from "@/models/user.interface";
import {attemptLogin} from "@/models/up.interface";
import {UserService} from "@/services/user.service";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import router from "@/router";
import {URL_LOGIN} from "@/config/utils";

export default defineComponent({
  name: 'LoginForm',
  setup(){
      const $gAuth = gAuth.useGAuth();
      const serviceUser = new UserService();
      const store = useStore();
      const route = useRoute();
      let attemptUploader :Ref<attemptLogin> = ref({email:"",password:""});

  onMounted(()=>{
	try{
	const userStored =  serviceUser.fetch();
	  if (!userStored){

	  //router.push("/login");
	   	  } 
	  else{
	store.dispatch("set_current_user",userStored);
	    router.push("/main");

	  }
	}catch(err){
	  console.log(err);
	}
      });

    const login = async()=>{
      const authCode = await $gAuth.signIn();
      const body=JSON.stringify(`{"honey":"${authCode.getAuthResponse().id_token}"}`);
      const resp=await fetch(`${URL_LOGIN}`,{method:"POST",headers:{"Content-Type":"application/json"},body:body});
      const body_response = await resp.json();
      if (resp.status==202){
	let user_authorized:Usuario= {
	    
	  token:body_response.response.access_token,
	  name: body_response.response.name,
	  lastname: body_response.response.last_name,
	  profiles: body_response.response.profiles,
	  picture: body_response.response.picture,
	};
	serviceUser.store(user_authorized);
	store.dispatch("set_current_user",user_authorized);
	if (user_authorized.profiles.includes("uploader")){router.push("/uploadfiles");}
	router.push("/main");
      }
      
    }//fin de login

    const loginUploader = async()=>{
	  const vari=await serviceUser.loginUploader(attemptUploader.value);
	  if (vari){
	  let user_authorized:Usuario= {
	    
	  token:vari.access_token,
	  name: vari.name,
	  lastname: vari.last_name,
	  profiles: vari.profiles,
	  picture: vari.picture,
	};
	  serviceUser.store(user_authorized);
	  store.dispatch("set_current_user",user_authorized);
	  router.push("/uploadfiles");
	  }
	  
    }//fin de loginUploader

      return {login,attemptUploader,loginUploader}
  }
});

